module.exports = __webpack_public_path__ + "img/play-btn.31122805.svg";